import { useState, useReducer, useContext } from "react";
import { GlobalContext } from "../globalContext";
import { endpoints, apiClient } from "../utils/constants";
import { trackEvent } from "../utils/gtmTracker";

export default function InfoModal({ onClose }) {
  
  const { store, updateStore, t } = useContext(GlobalContext);
  const [ state, updateState  ] = useReducer(
      (prev, next) => {
        return { ...prev, ...next };
      },
      {
        showConfirmation: false,
        privacyAccepted: false,
        confirmationError: false
      }
    );
  

  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");

  // Funzione di reset dei campi form e privacy
  function resetForm() {
    setNome("");
    setCognome("");
    setEmail("");
    updateState({ privacyAccepted: false });
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
     // ✅ Controllo privacy non accettata
    if (!state.privacyAccepted) {
      updateState({
        showConfirmation: true,
        confirmationError: true
      });
      return;
    }

    const payload = {
      nome: nome,
      cognome: cognome,
      email: email,
      comune: store.selectedAddress || "",
      codiceTopCliente: store.selectedCodeTopClient || "",
      type: "FTTH_PIANIFICATO_FTTC_ATTIVO"
    };

    apiClient
      .post(endpoints.subscribeEmailFromNewsletter, payload, false, true )
      .then(() => {
        // Tracciamento submit modal notifyme
        trackEvent("notifyme_modal_submit", {
          indirizzo: payload.comune,
          codiceTopCliente: payload.codiceTopCliente
        });
        updateState({confirmationError: false}); // <-- Successo
        updateState({showConfirmation: true});
        setTimeout(() => {
          resetForm();
          onClose();
        }, 2500);
    })
    .catch((error) => {
      let errorMessage = error?.message || 'unknown error';
      let statusCode = error?.response?.status;
      let errorString = '';
      if (statusCode) {
        errorString = `${statusCode}: ${errorMessage}`;
      } else {
        errorString = `Code not available: ${errorMessage}`;
      }

      trackEvent("notifyme_modal_submit_error", {
        notifyme_modal_submit_error: errorString,
        indirizzo: payload.comune
      });

      updateState({showConfirmation: true});      // Mostra modale anche in errore
      updateState({confirmationError: true});    // <-- Flag errore
    });
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button type="button" onClick={onClose} className="modal-close-button">
          x
        </button>
        <h2 className="modal-title">
          {t.titleModalArriving}
          <br />
          {t.titleModalArrivingTwo}</h2>

        <form className="modal-form"
              onSubmit={(e) => handleFormSubmit(e)}
        >
          <div className="modal-grid">
            <input type="text" placeholder={t.modalArrivingName} value={nome} onChange={(e) => setNome(e.target.value)} required />
            <input type="text" placeholder={t.modalArrivingSurname} value={cognome} onChange={(e) => setCognome(e.target.value)} required />
          </div>
          <input type="email" placeholder={t.modalArrivingEmail} value={email} onChange={(e) => setEmail(e.target.value)} required />

          <div className="modal-checkbox">
            <input
              type="checkbox"
              id="privacy"
              checked={state.privacyAccepted}
              onChange={() => updateState
                ({privacyAccepted: !state.privacyAccepted})}
            />
            <label htmlFor="privacy">
              {t.modalPrivacyCheckboxText}<a
               href="https://www.fibercop.it/informazioni/privacy/"
               target="_blank"
               rel="noreferrer"
              >{t.modalPrivacyCheckboxTextTwo}</a> {t.modalPrivacyCheckboxTextThree}
            </label>
            
            
          </div>

          <div className="privacy-text">
            {t.modalPrivacySubText}
          </div>

          <div className="modal-actions">
            <button
              className="modal-submit-button"
              type="submit"
            >
              {t.modalSubmit}
            </button>
          </div>

          {state.showConfirmation && (
      	    <div 
              className="modal-overlay"
              onClick={() => {
                updateState({showConfirmation: false});
                resetForm();
              }}>
              <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
                <button
                  className="modal-close"
                  onClick={() => {
                    updateState({showConfirmation: false});
                    resetForm();
                  }}
                  aria-label={t.closePopup}
                >
                  ✕
                </button>
                <p className="modal-text">
                  {state.confirmationError
                    ? state.privacyAccepted
                      ? t.newsletterError
                      : t.privacyRequired
                    : t.newsletterSuccess
                  }
                </p>
              </div>
            </div>
          )}

        </form>
      </div>
    </div>
  );
}
